import React from 'react';

const ChooseUs = () => {
  return (
    <>
      <div className="accordion-area abouts">
        <div className="container">
          <h2 style={{ textAlign: 'center' }}>From the CEO&apos;s Desk</h2>
          <h2 className="pb-50" style={{ textAlign: 'center' }}>
            A warm welcome to Amizhth Techno Solutions
          </h2>
          <div className="row">
            <div className="col-lg-6 p-0 main-accordion-lt">
              <div className="acd-items acd-arrow1 pt-30">
                <div className="section_title white text_left mt-3">
                  <div className="section_main_title">
                    <p style={{ textAlign: 'center' }}>
                      &quot;Amizhth Techno Solutions is
                    </p>
                    <p style={{ textAlign: 'center' }}>built around customer</p>
                    <p style={{ textAlign: 'center' }}>satisfaction.&quot;</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 absod">
              <div className="single-panel">
                <div className="single-panel-thumb">
                  <p style={{ marginLeft: '15px', textAlign: 'justify' }}>
                    At Amizhth, we believe that excellence comes from a deep
                    understanding of both technology and the unique needs of our
                    clients. As a team of passionate professionals, we are
                    committed to delivering solutions that not only meet today’s
                    challenges but also set the foundation for tomorrow’s
                    success. Our strength lies in our ability to listen, adapt,
                    and innovate—ensuring that every project is aligned with the
                    goals of our clients, whether it’s creating dynamic
                    websites, securing systems, or driving digital
                    transformation.
                  </p>
                  <p style={{ marginLeft: '15px', textAlign: 'justify' }}>
                    What sets us apart is our relentless pursuit of quality,
                    combined with a flexible approach tailored to each client.
                    We don’t just deliver software; we craft solutions that
                    evolve with your business. Our proven expertise in web
                    development, mobile applications, cybersecurity, and beyond,
                    paired with our customer-first mindset, ensures that your
                    success is at the heart of everything we do.
                  </p>
                  <p style={{ marginLeft: '15px', textAlign: 'justify' }}>
                    Together, we build not just products, but lasting
                    partnerships—because your growth is our ultimate measure of
                    success.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="accordion-area abouts">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 absod">
              <div className="single-panel1">
                <div className="single-panel-thumb">
                  <p
                    style={{
                      marginLeft: '10px',
                      textAlign: 'justify',
                      marginRight: '15px'
                    }}
                  >
                    A visionary Tech Thamizhan and enterprising techpreneur,
                    passionately uniting the realms of Thamizh and Technology.
                    With an unwavering dedication to both innovation and the
                    preservation of cultural heritage, he is carving a path
                    where advanced technology harmoniously coexists with the
                    timeless essence of Thamizh. Strongly believing that true
                    success is measured by the collective progress of every
                    individual in society, he is relentlessly working toward
                    creating an ecosystem that fosters inclusive growth,
                    empowerment, and shared prosperity.
                  </p>
                  <p
                    style={{
                      marginLeft: '10px',
                      fontWeight: 'bold',
                      fontSize: '30px',
                      color: 'black'
                    }}
                  >
                    Prabahar Murugan
                  </p>
                  <p
                    style={{
                      marginLeft: '10px',
                      color: 'black',
                      fontWeight: 'bold'
                    }}
                  >
                    Chief Executive Officer
                  </p>
                  <div
                    style={{
                      marginLeft: '10px',
                      fontWeight: 'bold',
                      fontSize: '30px'
                    }}
                    className="social-icons"
                  >
                    <a
                      href="https://www.facebook.com/praba.mur27"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a
                      href="https://www.linkedin.com/in/prabaharm/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                    <a
                      href="https://www.instagram.com/praba_thamizhan/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 main-accordion-lt">
              <div className="acd-items acd-arrow pt-30 pb-30">
                <div className="section_title white text_left mb-60 mt-3">
                  <div className="section_main_title">
                    <img src="/images/ceo.png" className="ceo-img img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="row">
            <div className="col-lg-6 main-accordion-lt">
              <div className="acd-items acd-arrow pt-30 pb-30">
                <div className="section_title white text_left mb-60 mt-3">
                  <div className="section_main_title">
                    <img src="/images/jkp.jpeg" className="ceo-img img-fluid" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 absod">
              <div className="single-panel1">
                <div className="single-panel-thumb">
                  <p
                    style={{
                      marginLeft: '10px',
                      textAlign: 'justify',
                      marginRight: '15px'
                    }}
                  >
                    His passion for nurturing talent continues through the
                    Featurepreneur slack community, an invitation-only platform
                    focused on student development. Even as he prepares to take
                    on his new role, Raja is actively seeking research interns
                    for his upcoming 10th research paper, proving that his
                    commitment to mentoring never wavers.
                  </p>
                  <p
                    style={{
                      marginLeft: '10px',
                      textAlign: 'justify',
                      marginRight: '15px'
                    }}
                  >
                    When he’s not shaping the future of tech education, you
                    might find him unwinding with a John Grisham novel - a small
                    glimpse into the human side of this inspiring tech mentor
                    who has dedicated his life to lifting others as he climbs.
                  </p>
                  <p
                    style={{
                      marginLeft: '10px',
                      textAlign: 'justify',
                      marginRight: '15px'
                    }}
                  >
                    For aspiring technologists, Raja’s journey shows that true
                    success isn’t just about personal achievement - it’s about
                    creating pathways for others to succeed. Through his blend
                    of technical expertise, practical industry experience, and
                    unwavering commitment to education, he continues to light
                    the way for the next generation of tech innovators.
                  </p>
                  <p
                    style={{
                      marginLeft: '10px',
                      fontWeight: 'bold',
                      fontSize: '30px',
                      color: 'black'
                    }}
                  >
                    ZACHARIA J.K.P.
                  </p>
                  <p
                    style={{
                      marginLeft: '10px',
                      color: 'black',
                      fontWeight: 'bold'
                    }}
                  >
                    Director of Growth Strategy
                  </p>
                  <div
                    style={{
                      marginLeft: '10px',
                      fontWeight: 'bold',
                      fontSize: '30px'
                    }}
                    className="social-icons"
                  >
                    <a
                      href="https://www.linkedin.com/in/raja-csp-raman/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default ChooseUs;
